import { isFrontendRouteBlocked } from '@/config/routeMapping';

export default {
    // Verificar se é Pro
    isPro: state => state.accessProfile?.slug === 'pro',
    
    // Verificar se é Starter
    isStarter: state => state.accessProfile?.slug === 'starter',
    
    // Verificar se é SysAdmin
    isSysAdmin: state => state.user?.is_sysadmin || false,
    
    // Obter todos os limites
    limits: state => state.accessProfile?.metadata?.limits || {},
    
    // Obter um limite específico
    getLimit: state => (limitName) => {
        return state.accessProfile?.metadata?.limits?.[limitName];
    },
    
    // Verificar se uma rota está bloqueada
    isRouteBlocked: state => (frontendPath) => {
        if (!state.accessProfile) return false;
        
        const blockedRoutes = state.accessProfile.metadata?.blocked_routes || [];
        return isFrontendRouteBlocked(frontendPath, blockedRoutes);
    },
    
    // Obter array de rotas bloqueadas
    blockedRoutes: state => {
        return state.accessProfile?.metadata?.blocked_routes || [];
    },
    
    // Obter nome do perfil
    profileName: state => {
        console.log(state.accessProfile)
        return state.accessProfile?.name || ''
    },
    
    // Obter slug do perfil
    profileSlug: state => state.accessProfile?.slug || '',
    
    // ========== GETTERS DE EXPIRAÇÃO PRO ==========
    
    /**
     * Status completo do perfil incluindo informações de expiração
     */
    profileStatus: state => {
        const user = state.user;
        const profile = state.accessProfile;
        
        // Se não tem perfil ou não é Pro
        if (!profile || profile.slug !== 'pro') {
            return {
                isPro: false,
                isStarter: profile?.slug === 'starter',
                isBlocked: !profile, // Sem perfil = trial expirado, acesso bloqueado
                isTemporary: false,
                isPermanent: false
            };
        }
        
        const expiresAt = user?.profile_expires_at;
        
        // Pro Permanente (sem data de expiração)
        if (!expiresAt) {
            return {
                isPro: true,
                isStarter: false,
                isBlocked: false,
                isTemporary: false,
                isPermanent: true,
                expiresAt: null,
                daysRemaining: null,
                isExpired: false,
                isExpiringSoon: false
            };
        }
        
        // Pro Temporário (com data de expiração)
        const expirationDate = new Date(expiresAt);
        const now = new Date();
        const diffTime = expirationDate - now;
        const daysRemaining = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        
        return {
            isPro: daysRemaining >= 0, // Ainda é Pro se não expirou
            isStarter: false,
            isBlocked: daysRemaining < 0, // Bloqueado se expirou
            isTemporary: true,
            isPermanent: false,
            expiresAt: expirationDate,
            daysRemaining: daysRemaining,
            isExpired: daysRemaining < 0,
            isExpiringSoon: daysRemaining >= 0 && daysRemaining <= 7
        };
    },
    
    /**
     * Verifica se Pro é temporário
     */
    isProTemporary: (state, getters) => {
        return getters.profileStatus.isTemporary;
    },
    
    /**
     * Verifica se Pro é permanente
     */
    isProPermanent: (state, getters) => {
        return getters.profileStatus.isPermanent;
    },
    
    /**
     * Dias até expiração (null se permanente ou não Pro)
     */
    daysUntilExpiration: (state, getters) => {
        return getters.profileStatus.daysRemaining;
    },
    
    /**
     * Verifica se está expirando em breve (<= 7 dias)
     */
    isExpiringSoon: (state, getters) => {
        return getters.profileStatus.isExpiringSoon;
    },
    
    /**
     * Verifica se Pro já expirou
     */
    isProExpired: (state, getters) => {
        return getters.profileStatus.isExpired;
    },
    
    /**
     * Verifica se o acesso está bloqueado (sem perfil - trial expirado)
     */
    isBlocked: state => !state.accessProfile
};
